import { Box } from "@mui/material";
import { ActivityHeaderSectionLayout } from "../../layer31";
import Image from "../../../../assets/handWave.png";
import { useAppSelector } from "utils/redux/hooks";
import { selectCurrentUserInfo } from "app/containers/Global/slice";
import { useGetCriticalIssuesQuery } from "app/containers/TeamsTab/teamsCheckInApi";

export const DashboardActivityHeaderSection = () => {
  const loggedInUser = useAppSelector(selectCurrentUserInfo);
  const { data: issues = [] } = useGetCriticalIssuesQuery({
    showDismissed: false,
  });

  const getSubTitle = () => {
    if (issues.length === 0) {
      return "You're all caught up this week!";
    }
    return `Let's get you going on the ${issues.length} ${
      issues.length === 1 ? "item" : "items"
    } due this week.`;
  };

  return (
    <ActivityHeaderSectionLayout
      title={`Welcome back, ${loggedInUser?.firstName || "User"}!`}
      icon={
        <Box
          component="img"
          sx={{
            mixBlendMode: "darken",
          }}
          src={Image}
        />
      }
      subtitle={getSubTitle()}
    />
  );
};
